export const AuthType = {
  0: 'basic',
  1: 'token',
  2: 'bearerToken',
  3: 'httpDigest',
  4: 'oauth',
  5: 'webhook',
};
